'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { useIsSticking } from '@repo/web-ui/hooks/use-is-sticking'
import { ClientOnly } from 'components/client-only'

type StickyProps = React.PropsWithChildren

export function Sticky({ children }: StickyProps) {
  const [stickyEl, setStickyEl] = React.useState<HTMLDivElement | null>(null)
  const isSticking = useIsSticking(stickyEl, 30)

  return (
    <ClientOnly>
      <div
        ref={setStickyEl}
        id="sticky-cta-button"
        className={tw(
          isSticking && 'opacity-0',
          'transition-all duration-300 ease-in-out',
          'bg-cf-white text-cool-gray-1000 sticky left-[calc(100%-282px-1rem)] top-[calc(100%-170px-1rem)] z-10 mb-4 flex max-w-[282px] flex-col items-start gap-6 rounded-[24px] p-6 lg:left-[70%]',
          'hidden md:flex',
        )}
      >
        {children}
      </div>
    </ClientOnly>
  )
}
